import axios from 'axios';
import Config from '../config/Config';
import Loader from './Loader';

/**
 * Request Wrapper with default success/error actions
 */
const Api = function (options, isExternalApi = 0) {
	/**
	 * Create an Axios Client with defaults
	 */
	const client = axios.create({
		baseURL: isExternalApi === 2 ? '' : isExternalApi === 1 ? Config.LTAPIURL : Config.APIURL,
	});
	if(options.showLoader !== false) {
		Loader.show();
	}
	const onSuccess = function (response) {
		return response.data;
	};

	const onError = function (error) {
		if (error.response) {
			// Request was made but server responded with something
			// other than 2xx
			if (error.response.data.status) {
				return error.response.data.message;
			} else {
				return 'Oops, something went wrong. Please try again';
			}
		} else {
			// Something else happened while setting up the request
			// triggered the error
			return error.message;
		}
	};
	if (options.headers !== undefined) {
		options.headers['platform'] = 'w1';
	}
	if (!isExternalApi && options.url !== 'v3/user_profile') {
		options.url = 'v1/' + options.url;
	}
	return client(options).then(onSuccess).catch(onError);
};

export default Api;
